import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Analyticsreportingyeppy = () => {
  return (
    <div className="analyticsreporting_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={4} xxl={4} className="my-auto">
            <h2>Analytics Reporting</h2>
            <div className="analytics_report_main">
              <ul>
                <li>User Testing</li>
                <p>
                  We conducted user testing sessions with a diverse group of 30
                  users to evaluate their interaction with the Yeppy Super App.
                </p>
                <li>Usage Analysis</li>
                <p>
                  The analysis of user interactions and time spent on various
                  services within the app revealed the following insights
                </p>
              </ul>
            </div>
          </Col>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="offset-xl-1">
            <div className="analy_report_mob_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/analy_reporting.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={820}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Analyticsreportingyeppy;
